export default "__VITE_ASSET__DDZ5vkTs__"